import Vue from 'vue'
import LoadingOpts from './Loading.vue'

const CONTEXT = 'LOADING_CONTEXT'
const Loading = Vue.extend(LoadingOpts)

const getMask = el => {
  return (el[CONTEXT] = el[CONTEXT] || new Loading().$mount())
}

const toggleMask = (el, binding, vnode) => {
  const mask = getMask(el)
  const fullscreen = binding.modifiers.fullscreen
  const container = fullscreen ? document.body : el

  Object.assign(mask, {
    visible: !!binding.value,
    zIndex: binding.arg || undefined,
    fullscreen
  })

  container.appendChild(mask.$el)
}

Vue.directive('loading', {
  bind: toggleMask,
  update: toggleMask,

  // 解除绑定
  unbind(el, binding, vnode) {
    const mask = getMask(el)
    const maskEl = mask.$el

    mask.$destroy()
    maskEl && maskEl.parentElement && maskEl.parentElement.removeChild(maskEl)
    el[CONTEXT] = null
  }
})
